module.exports = __webpack_public_path__ + "static/media/next.380cb42f.svg";